import { ChangeLogModalService } from './../change-log-modal.service';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'change-log-add-modal',
  templateUrl: './change-log-add-modal.component.html',
})
export class ChangeLogAddModalComponent {

  form: UntypedFormGroup = new UntypedFormGroup({
    title: new UntypedFormControl((this.data || {}).title, Validators.required),
    description: new UntypedFormControl((this.data || {}).description, Validators.required),
    changeDate: new UntypedFormControl((this.data || {}).changeDate, Validators.required),
    revision: new UntypedFormControl((this.data || {}).revision, Validators.required)
  });

  constructor(
    private readonly changeLogService: ChangeLogModalService,
    private readonly dialogRef: MatDialogRef<ChangeLogAddModalComponent>,
    @Inject(MAT_DIALOG_DATA) private readonly data: any
  ) { }

  saveChangeLog() {
    if (this.data) {
      this.changeLogService.editChangeLog({ id: this.data.id, ...this.form.value })
        .subscribe(response => this.dialogRef.close(response));
    } else {
      this.changeLogService.addChangeLog(this.form.value)
        .subscribe(response => this.dialogRef.close(response));
    }
  }
}
